import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import useGlobalModel from "./model/globalModel";
import { Login } from "./views/login/Login";
import TokenLogin from './views/login/TokenLogin'
import Index from "./layout";
import { setToken } from './utils/constants';
import { useScmSaleRoDetailModel } from './views/scmBill/scmSaleRo/scmSaleRoModel'
import { useVrmSaleRoDetailModel } from "@/views/vrmBill/vrmBillSaleRo/vrmBillSaleRoModel"
import { useBmsSaleRoDetailModel } from "@/views/bmsBill/bmsBillSaleRo/bmsBillSaleRoModel"
function App() {
    const { user, requestCatchAll, getBranch } = useGlobalModel()
    const { loadScmDictData } = useScmSaleRoDetailModel()
    const { loadVrmDictData } = useVrmSaleRoDetailModel()
    const { loadBmsDictData } = useBmsSaleRoDetailModel()
    const { loadNgaDictData } = useScmSaleRoDetailModel()
    useEffect(() => {
        if (user.token) {
            requestCatchAll();
            loadScmDictData()
            loadVrmDictData()
            loadBmsDictData()
            loadNgaDictData()
            getBranch()
        }
    }, [user.token])

    function loginCheck() {
        // const url = 'https://localhost:3000?token=90d587565ba24df99d4f804fb931d2c8'
        const url = window.location.href
        let urlObj: { [proppName: string]: string; } = {}

        /*
        * 正则匹配
        * [?&]:匹配?或&其一
        * [^?&]:非?或非&
        * */
        let reg = /[?&][^?&]+=[^?&]+/g
        let arr = url.match(reg)
        if (arr) {
            arr.forEach((item) => {
                let tempArr = item.substring(1).split('=')
                let key: string = tempArr[0]
                let val: string = tempArr[1]
                urlObj[key] = val
            })
        }
        if (urlObj.token) {
            setToken(urlObj.token)
            return <TokenLogin token={urlObj.token} />
        }
        return <Login />
    }
    return (
        <Switch>
            <Route path="/login" component={() => loginCheck()} />
            <Route path="/" render={
                () => user.token ? <Index /> : <Redirect to="/login" />}
            />
        </Switch>
    );
}

export default App;
